export default [
  {
    icon: 'mdi-teach',
    title: 'Kelas Diklat',
    desc: 'Kelola diklat kelas dan peserta diklat',
    color: 'success',
    deepColor: 'darken-1',
    link: 'kelas',
    akses: true,
    to: { name: 'kelas' },
  },
  {
    icon: 'mdi-file-edit-outline',
    title: 'Klaim Diklat Luring',
    desc: '',
    color: 'success',
    deepColor: 'darken-1',
    link: 'klaim',
    akses: true,
    to: { name: 'klaim' },
  },
];
